<div y42ArrowNavigationContainer class="container">
  <div class="menu-header menu-header-search">
    <div class="filterable-list custom-mat-form-wrapper">
      <mat-form-field appearance="fill" subscriptSizing="dynamic">
        <div matPrefix>
          <fa-icon [icon]="['fal', 'search']"></fa-icon>
        </div>
        <input
          y42ArrowNavigable
          matInput
          [cdkTrapFocus]
          [cdkTrapFocusAutoCapture]="true"
          [formControl]="searchControl"
          [placeholder]="state.searchPlaceholder"
        />
      </mat-form-field>
    </div>
  </div>

  <button
    y42ArrowNavigable
    mat-flat-button
    color="primary"
    *ngIf="state.isCreateButtonEnabled && !isUX3"
    class="create-btn"
    (click)="create(searchControl.value)"
  >
    {{ createItemButtonLabel }}: "{{ searchControl.value }}"
  </button>

  <div
    *ngIf="enableSelectedItemsListSummary && state.selectedItems.length > 0"
    class="w-full mb-[8px] bg-gray-300 rounded p-[8px] overflow-x-auto"
  >
    <mat-chip-list>
      <mat-chip
        *ngFor="let item of state.selectedItems; trackBy: trackByIdentity"
        (removed)="setSelection(item, false)"
      >
        <ng-container
          *ngTemplateOutlet="
            summaryItemTemplate;
            context: {
              $implicit: item,
              itemsFilter: state.itemsFilter.value
            }
          "
        ></ng-container>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-list>
  </div>

  <span *ngIf="state.isEmptyListLabelEnabled" class="empty-text" [class.empty-text-absolute]="isUX3">
    {{ emptyListLabel }}
  </span>

  <ng-container *ngIf="state.isRegularList">
    <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="items-wrapper">
      <button
        y42ArrowNavigable
        mat-menu-item
        *cdkVirtualFor="let item of state.items; trackBy: trackByIdentity"
        (click)="setSelection(item, true)"
        class="w-full"
        [class.px-space-x2]="isUX3"
        [ngClass]="{ active: state.selection[item] }"
      >
        <ng-container
          *ngTemplateOutlet="
            itemTemplate ?? defaultTemplate;
            context: {
              $implicit: item,
              itemsFilter: state.itemsFilter.value
            }
          "
        ></ng-container>
      </button>
    </cdk-virtual-scroll-viewport>
  </ng-container>

  <ng-container *ngIf="state.isToggledList">
    <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="items-wrapper">
      <div mat-menu-item *cdkVirtualFor="let item of state.items; trackBy: trackByIdentity" class="item w-full">
        <mat-checkbox
          color="primary"
          [ngModel]="state.selection[item | identify : identityFn]"
          [disableRipple]="true"
          (ngModelChange)="setSelection(item, $event)"
        >
          <ng-container
            *ngTemplateOutlet="
              itemTemplate ?? defaultTemplate;
              context: { $implicit: item, itemsFilter: state.itemsFilter.value }
            "
          ></ng-container>
        </mat-checkbox>
      </div>
    </cdk-virtual-scroll-viewport>
  </ng-container>

  <button
    y42ArrowNavigable
    mat-flat-button
    *ngIf="state.isCreateButtonEnabled && isUX3"
    class="create-btn-bottom"
    (click)="create(searchControl.value)"
  >
    <y42-icon [icon]="'plus'" class="mr-space"></y42-icon> {{ createItemButtonLabel }}:
    <span class="text-typography-secondary truncate text-left">"{{ searchControl.value }}"</span>
  </button>
</div>

<ng-template #defaultTemplate let-item>
  {{ item }}
</ng-template>
